export default "__VITE_ASSET__BeG3Kz39__"